"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ArticleGrid = _interopRequireDefault(require("./ArticleGrid"));

var _ArticleTitle = _interopRequireDefault(require("./ArticleTitle"));

var _ArticleLeadtext = _interopRequireDefault(require("./ArticleLeadtext"));

var _ArticleBodytext = _interopRequireDefault(require("./ArticleBodytext"));

var _ArticleMedia = _interopRequireDefault(require("./ArticleMedia"));

var _ArticleReferences = _interopRequireDefault(require("./ArticleReferences"));

var _ArticleLinks = _interopRequireDefault(require("./ArticleLinks"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ArticleSection = ({
  sectionType,
  sectionLayout,
  language = "no",
  title,
  leadtext,
  bodytext,
  links = [],
  media = [],
  references = []
}) => {
  if (sectionType === "media") {
    return _react.default.createElement(_ArticleGrid.default, null, _react.default.createElement(_ArticleTitle.default, {
      component: "h2",
      language: language
    }, title), _react.default.createElement(_ArticleMedia.default, {
      layout: sectionLayout,
      language: language,
      media: media
    }), _react.default.createElement(_ArticleBodytext.default, {
      language: language
    }, bodytext));
  }

  if (sectionType === "references") {
    return _react.default.createElement(_ArticleGrid.default, null, _react.default.createElement(_ArticleTitle.default, {
      component: "h2",
      language: language
    }, title), _react.default.createElement(_ArticleLeadtext.default, {
      language: language
    }, leadtext), _react.default.createElement(_ArticleReferences.default, {
      language: language,
      references: references
    }));
  }

  return _react.default.createElement(_ArticleGrid.default, null, _react.default.createElement(_ArticleTitle.default, {
    component: "h2",
    language: language
  }, title), _react.default.createElement(_ArticleMedia.default, {
    layout: sectionLayout,
    language: language,
    media: media
  }), _react.default.createElement(_ArticleLeadtext.default, {
    language: language
  }, leadtext), _react.default.createElement(_ArticleReferences.default, {
    language: language,
    references: references
  }), _react.default.createElement(_ArticleBodytext.default, {
    language: language
  }, bodytext), _react.default.createElement(_ArticleLinks.default, {
    language: language,
    links: links
  }));
};

var _default = ArticleSection;
exports.default = _default;
module.exports = exports.default;